export const CHECKOUT_URL = 'https://lengua-y-literatura-2026.impultienda.ar/checkout'

/* Todos los botones e imágenes llevan a la sección de compra */
export const OFFER_ANCHOR = '#oferta'

export const SUPPORT_EMAIL = 'soportescmdigital@gmail.com'

export const PACK_IMAGE =
  'https://cdn.magicpatterns.com/uploads/kr5Za6KAM1U3rcjpifNdML/Mega_Pack_Lengua_y_Literatura_2026.png'

export const PRODUCT_NAME = 'MEGA PACK LENGUA Y LITERATURA 2026'

export const PRICE = '$19.990'

export const BONUS_TOTAL = '$39.950'

/* 1. PROBLEMA */
export const problems = [
  {
    title: '📚 INFORMACIÓN DISPERSA',
    desc: 'Buscás explicaciones, obras literarias, ejercicios y actividades en diferentes páginas, libros y archivos, pero nunca encontrás todo organizado para trabajar de manera práctica.',
  },
  {
    title: '⏰ PERDÉS HORAS PREPARANDO MATERIAL',
    desc: 'Tenés que planificar clases, buscar textos, crear consignas y preparar evaluaciones desde cero. El tiempo pasa y todavía te quedan materiales por organizar.',
  },
  {
    title: '📝 TE FALTAN RECURSOS PRÁCTICOS',
    desc: 'Necesitás actividades, guías de lectura, ejercicios resueltos y evaluaciones que te permitan enseñar, practicar o repasar sin tener que crear cada recurso por separado.',
  },
  {
    title: '😓 SEGUÍS POSTERGANDO',
    desc: 'Querés tener tus clases y materiales organizados, o mejorar tu comprensión de Lengua y Literatura, pero seguís buscando recursos sueltos sin contar con un sistema completo.',
  },
]

/* 2. SOLUCIÓN — 6 TOMOS */
export const tomos = [
  {
    title: 'FUNDAMENTOS DE LENGUA Y LITERATURA',
    desc: 'Comprendé comunicación, lenguaje, coherencia, cohesión, tipos de textos, géneros literarios, narración, poesía, teatro y comprensión lectora mediante explicaciones, ejemplos y actividades prácticas.',
  },
  {
    title: 'LITERATURA ARGENTINA Y LATINOAMERICANA',
    desc: 'Estudiá los principales movimientos, autores y obras de Argentina y Latinoamérica, desde el Romanticismo y la gauchesca hasta las vanguardias y la narrativa contemporánea, con análisis y ejercicios.',
  },
  {
    title: 'LITERATURA UNIVERSAL Y GRANDES CLÁSICOS',
    desc: 'Conocé las principales etapas de la literatura universal, sus autores, obras y movimientos, desde la Antigüedad hasta el siglo XX, con guías de análisis y actividades comparativas.',
  },
  {
    title: 'GRAMÁTICA, ORTOGRAFÍA Y ESCRITURA',
    desc: 'Aprendé clases de palabras, análisis sintáctico, verbos, acentuación, puntuación, conectores y producción escrita mediante explicaciones claras, ejemplos y ejercicios con soluciones.',
  },
  {
    title: 'COMPRENSIÓN LECTORA Y ANÁLISIS LITERARIO',
    desc: 'Desarrollá herramientas para interpretar cuentos, poemas, obras teatrales y textos argumentativos, identificar ideas principales, realizar inferencias y fundamentar respuestas mediante actividades prácticas.',
  },
  {
    title: 'PLANIFICACIÓN DOCENTE Y EVALUACIONES',
    desc: 'Accedé a modelos de planificación anual, secuencias didácticas, clases organizadas, evaluaciones, rúbricas y herramientas de seguimiento para preparar y adaptar materiales educativos.',
  },
]

/* 3. BONOS */
export const bonuses = [
  {
    title: '100 ACTIVIDADES PRÁCTICAS DE LENGUA Y LITERATURA',
    desc: 'Un banco de 100 ejercicios de comunicación, gramática, ortografía, comprensión lectora, literatura y escritura, con respuestas y ejemplos para practicar, repasar y utilizar en clase.',
    value: '$7.990',
  },
  {
    title: '50 EVALUACIONES CON RESPUESTAS',
    desc: '50 modelos breves de evaluación con consignas, soluciones y criterios de corrección para trabajar comunicación, gramática, ortografía, literatura y comprensión lectora.',
    value: '$5.990',
  },
  {
    title: 'GUÍAS DE LECTURA DE OBRAS FUNDAMENTALES',
    desc: '15 guías de lectura con contexto, autores, personajes, temas, preguntas de análisis y respuestas orientativas para estudiar obras argentinas, latinoamericanas y universales.',
    value: '$6.990',
  },
  {
    title: 'SECUENCIAS DIDÁCTICAS PARA SECUNDARIA',
    desc: '10 secuencias de enseñanza organizadas en clases, con objetivos, actividades, recursos, producciones y criterios de evaluación para adaptar al trabajo docente.',
    value: '$8.990',
  },
  {
    title: 'MAPAS CONCEPTUALES Y RESÚMENES VISUALES',
    desc: '20 fichas conceptuales sobre gramática, géneros literarios, comprensión lectora, recursos expresivos y literatura, para repasar, organizar contenidos y facilitar el estudio.',
    value: '$9.990',
  },
]

/* 4. BENEFICIOS */
export const benefits = [
  {
    title: '📚 MENOS TIEMPO BUSCANDO MATERIAL',
    desc: 'Dejá de recorrer páginas, archivos y libros para reunir información. Accedé a contenidos organizados por temas, con explicaciones, ejemplos y ejercicios en un solo sistema.',
  },
  {
    title: '📝 MÁS RECURSOS PARA TUS CLASES',
    desc: 'Contá con actividades, evaluaciones, guías de lectura, secuencias didácticas y modelos de planificación que podés adaptar a tus necesidades.',
  },
  {
    title: '🧠 COMPRENDÉ MEJOR CADA TEMA',
    desc: 'Estudiá gramática, literatura, comprensión lectora y escritura con explicaciones ordenadas, ejercicios prácticos y respuestas orientativas que facilitan el aprendizaje.',
  },
  {
    title: '🚀 MÁS ORGANIZACIÓN Y CONFIANZA',
    desc: 'Prepará tus clases, repasá contenidos y organizá evaluaciones con una base de materiales que te permita avanzar de forma más clara y aprovechar mejor tu tiempo.',
  },
]

/* 5. TESTIMONIOS */
export const testimonials = [
  {
    label: 'TESTIMONIO 1 — DOCENTE DE LENGUA Y LITERATURA',
    quote:
      'Doy clases en tres cursos y cada domingo se me iba la tarde armando material. Con los tomos ordenados por tema ya no arranco de cero: tomo la secuencia de géneros literarios, la adapto al curso y en una hora tengo la semana lista. Las evaluaciones con criterios de corrección me ahorraron muchísimo tiempo en el cierre del trimestre.',
    author: 'Mariela Sosa',
    detail: '42 años · Córdoba, Argentina',
  },
  {
    label: 'TESTIMONIO 2 — PROFESORA DE SECUNDARIA',
    quote:
      'Lo que más uso son las 100 actividades y las 50 evaluaciones con respuestas. Las imprimo, las mezclo según el nivel y las uso como tarea o repaso antes de las pruebas. Mis alumnos de 2.º año mejoraron mucho en ortografía y puntuación porque ahora practican todas las semanas con consignas claras.',
    author: 'Lorena Paz',
    detail: '36 años · Rosario, Argentina',
  },
  {
    label: 'TESTIMONIO 3 — ESTUDIANTE DE 5.º AÑO',
    quote:
      'El análisis sintáctico siempre me costaba y me llevaba previas. Con el tomo de gramática y los mapas conceptuales entendí cómo identificar sujeto, predicado y modificadores paso a paso. También usé las guías de lectura para el Martín Fierro y llegué a la evaluación sabiendo qué temas y personajes analizar. Aprobé con 8.',
    author: 'Agustina Ledesma',
    detail: '17 años · Mar del Plata, Argentina',
  },
  {
    label: 'TESTIMONIO 4 — DOCENTE',
    quote:
      'Las guías de lectura de obras fundamentales son lo mejor del pack. Tienen contexto, temas y preguntas de análisis listas para trabajar en clase. Las usé con "La casa de Bernarda Alba" y con cuentos de Cortázar, y los chicos participaron mucho más porque sabían qué buscar en cada texto.',
    author: 'Gustavo Herrera',
    detail: '51 años · Mendoza, Argentina',
  },
  {
    label: 'TESTIMONIO 5 — PROFESORA DE LENGUA',
    quote:
      'Recién me recibí y la planificación anual me resultaba abrumadora. Los modelos de planificación, las secuencias didácticas y las rúbricas me dieron una base sólida para presentar en la escuela. Ahora organizo mis clases con más confianza y adapto cada material al curso sin perder horas buscando recursos sueltos.',
    author: 'Florencia Acuña',
    detail: '27 años · San Miguel de Tucumán, Argentina',
  },
]

/* 6. FAQ */
export const faqs = [
  { q: '¿Es físico o digital?', a: 'Es un producto 100% digital.' },
  {
    q: '¿Necesito conocimientos previos?',
    a: 'No necesariamente. Incluye explicaciones desde los fundamentos y materiales que pueden adaptarse a distintos niveles de secundaria.',
  },
  {
    q: '¿Qué voy a aprender?',
    a: 'Comunicación, gramática, ortografía, escritura, comprensión lectora, géneros literarios, literatura argentina, latinoamericana y universal, además de planificación y evaluación docente.',
  },
  {
    q: '¿Incluye ejercicios?',
    a: 'Sí. Incluye actividades prácticas, ejercicios con respuestas, análisis de textos, evaluaciones y recursos didácticos para aplicar los contenidos.',
  },
  {
    q: '¿Los bonos tienen costo adicional?',
    a: 'No. Los 5 bonos están incluidos sin costo adicional con la compra del Mega Pack.',
  },
  {
    q: '¿Es un pago único?',
    a: 'Sí. Realizás un único pago de $19.990, sin mensualidades.',
  },
  {
    q: '¿Obtengo acceso inmediatamente?',
    a: 'Sí. Es un producto digital con acceso inmediato después de confirmar la compra.',
  },
  {
    q: '¿Esto me habilita profesionalmente?',
    a: 'No. Es material educativo complementario. No otorga título oficial, certificación docente ni habilitación profesional.',
  },
  {
    q: '¿Puedo aprender a mi ritmo?',
    a: 'Sí. Podés consultar los materiales digitales y avanzar según tus necesidades de estudio o planificación.',
  },
  {
    q: '¿Dónde solicito soporte?',
    a: 'Podés escribir a nuestro correo de atención: soportescmdigital@gmail.com.',
  },
]

/* POP-UP DE COMPRAS RECIENTES — ARGENTINA */
export const recentBuyers = [
  { name: 'Prof. Mariana Ruiz', city: 'Córdoba', minutes: 2 },
  { name: 'Sofía Benítez', city: 'Rosario', minutes: 4 },
  { name: 'Prof. Andrea Molina', city: 'Buenos Aires', minutes: 6 },
  { name: 'Julieta Domínguez', city: 'Mendoza', minutes: 9 },
  { name: 'Prof. Ricardo Paz', city: 'La Plata', minutes: 13 },
  { name: 'Camila Ortiz', city: 'Mar del Plata', minutes: 17 },
  { name: 'Prof. Verónica Sánchez', city: 'Salta', minutes: 22 },
  { name: 'Valentina Ríos', city: 'San Miguel de Tucumán', minutes: 27 },
  { name: 'Prof. Natalia Correa', city: 'Neuquén', minutes: 31 },
  { name: 'Mateo Aguirre', city: 'Santa Fe', minutes: 38 },
]
